import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import "./styles.css";
import { Auth } from "aws-amplify";
import TopAlert from "../../../components/TopNotification/TopAlert";

const ChangePasswordTab = () => {
  const [oldPass, setOldPass] = useState("");
  const [newPass, setNewPass] = useState("");
  const [setPass, setSetPass] = useState("");
  const [showAlert, setShowAlert] = useState();
  const [alertMsg, setAlertMsg] = useState();
  const [alertType, setAlertType] = useState();
  const [greenPassMatch, setGreenPassMatch] = useState(false);

  const [form] = Form.useForm();

  const onFinish = (values) => {
   
   if (values.oldPassword === values.newPassword && values.oldPassword=== values.password) {
    setShowAlert(true);
    setAlertType("error");
    setAlertMsg("old password and new password cannot be same");
    }
   else {
            
    Auth.currentAuthenticatedUser()
    .then((user) => {

      return Auth.changePassword(user, oldPass, setPass);
     
    })
    .then((data) => {

      setShowAlert(true);

      setAlertType("success");
      setAlertMsg("Password successfully changed");
      setOldPass("");
      setNewPass("");
      setSetPass("");
      form.resetFields();
    })
  
    .catch((err) => {


      setShowAlert(true);
      setAlertType("error");
      setAlertMsg("Incorrect Password");
      form.resetFields();
      setOldPass("");
      setNewPass("");
      setSetPass("");
      switch (err.code) {
        case "LimitExceededException":
          setShowAlert(true);
          setAlertType("error");
          setAlertMsg("Limed Exceeded. Please try gain after some time");

          break;
        case "NotAuthorizedException":

          break;
      }
    });
    }
  };
  const checkPassword = (_, value) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;

    if (value) {
      if (!passwordRegex.test(value)) {
        return Promise.reject(new Error("Password must be 8 characters long and contain one uppercase, one lowercase, and one number."));
      }

      if (value && value == newPass) {
        setSetPass(value);
        if (setPass === newPass) {
          setGreenPassMatch(true);
        }
        return Promise.resolve();
      } 
      else {
        return Promise.reject(new Error("Passwords do not match!"));
      }
    } 
    else {
      return Promise.reject(new Error("Please confirm your password."));
    }

  }; 

  const checkNewPassword = (_, value) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).{8,}$/;
  
    if (value) {
      if (!passwordRegex.test(value)) {
        return Promise.reject(new Error("Password must be 8 characters long and contain one uppercase, one lowercase, and one number."));
      }
      else{
        return Promise.resolve();
      }
  
    } else {
      return Promise.reject(new Error("Please input your new password."));
    }
  };
  
 
  

  
  return (
    <div
      className="changePassword-main-Div"
      style={{
        paddingLeft: "3%",
      }}
    >
      {showAlert && (
        <TopAlert
          type={alertType}
          title={alertMsg}
          display={showAlert && "block"}
          setAlert={setShowAlert}
        />
      )}
      <Form
        form = {form}
        name="normal_login"
        className="login-form"
        // initialValues={{ remember: true }}
        onFinish={onFinish}
      >
        <Form.Item
          className="change-password-form-item"
          name="oldPassword"
          // initialValue={oldPass}
          rules={[{ required: true, message: "Please input your Password!" }]}
          style={{ marginBottom: "8px", marginTop: "1%" }}
          
        >
          <Input.Password
            value={oldPass}
            placeholder="Current password"
            className="myProfile-confirm-password"
            onChange={(e) => {
              setOldPass(e.target.value);
            }}
            iconRender={(visible) =>
              visible ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Hide
                </span>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Show
                </span>
              )
            }
          />
        </Form.Item>
        <Form.Item
          className="change-password-form-item "
          name="newPassword"
          rules={[
    
            {
              validator: checkNewPassword,
            },
          ]}
          // rules={[
          //   { required: true, message: "Please input your new password" },
          // ]}
          style={{ marginBottom: "8px", marginTop: "1%" }}
          // initialValue={newPass}
        >
          <Input.Password
            value={newPass}
            placeholder="New password"
            className={`myProfile-confirm-password ${
              greenPassMatch && "validInputCSS"
            }`}
            onChange={(e) => {
              setNewPass(e.target.value);
            }}
            iconRender={(visible) =>
              visible ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Hide
                </span>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Show
                </span>
              )
            }
          />
        </Form.Item>
        <Form.Item
          className="change-password-form-item"
          style={{ marginBottom: "8px", marginTop: "1%" }}
          name="password"
          rules={[
    
            {
              validator: checkPassword,
            },
          ]}
        >
          <Input.Password
            value={setPass}
            className={`myProfile-confirm-password ${
              greenPassMatch && "validInputCSS"
            }`}
            placeholder="Re-enter new password"
            iconRender={(visible) =>
              visible ? (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Hide
                </span>
              ) : (
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: 500,
                    fontStretch: "normal",
                    fontStyle: "normal",
                    lineHeight: "normal",
                    letterSpacing: "normal",
                    textAlign: "right",
                    color: "#4054b2",
                  }}
                >
                  Show
                </span>
              )
            }
            type="password"
          />
        </Form.Item>
        <p className="howpasswordshouldbe">
        Password must contain at least 8 characters. Combine numbers, upper and lowercase letters.
        </p>
        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="myprofile-form-button"
          >
            Change password
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
export default ChangePasswordTab;
